import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type HsaFlatTeamSettingGroupId = "hsa.buy_buttons";

const hsaSettingsOwner: SettingOwner = {
  kind: "teamSettings",
  path: "settings.hsa",
  product: "payments",
};

const hsaCheckoutRisk: SettingRisk = {
  level: "medium",
  reason:
    "Changes what shoppers see at checkout when they use a Buy with HSA/FSA button.",
};

// NOTE: no availability condition yet — the page's nav gate
// (`team.settings.hsa.enabled`) has no catalog evaluator; needs a new one.
export const HsaFlatTeamSettingGroups = [
  {
    id: "hsa.buy_buttons",
    title: "Buy with HSA buttons",
    description:
      "Behavior of storefront Buy with HSA/FSA buttons that call the Redo HSA window API (window.RedoHsa). Only affects checkouts entered through those buttons.",
    productArea: "payments",
    access: directMerchantAccess(
      SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
    ),
    owner: hsaSettingsOwner,
    risk: hsaCheckoutRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "payments/hsa" },
    synonyms: [
      "hsa buy button",
      "buy with hsa",
      "hsa fsa checkout button",
      "redo hsa window api",
    ],
    changeGuidance: {
      summary:
        "Confirm before changing how HSA buy-button checkouts present payment methods.",
    },
  },
] as const satisfies readonly SettingGroupDefinition<HsaFlatTeamSettingGroupId>[];

export const HsaFlatTeamSettingGroupById: Record<
  HsaFlatTeamSettingGroupId,
  SettingGroupDefinition<HsaFlatTeamSettingGroupId>
> = (() => {
  const map: Partial<
    Record<
      HsaFlatTeamSettingGroupId,
      SettingGroupDefinition<HsaFlatTeamSettingGroupId>
    >
  > = {};
  for (const group of HsaFlatTeamSettingGroups) {
    map[group.id] = group;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  return map as Record<
    HsaFlatTeamSettingGroupId,
    SettingGroupDefinition<HsaFlatTeamSettingGroupId>
  >;
})();
